import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';

const HeaderAvalia = ({ schoolName, schoolYear, dreAndMunicipio, student }) => {
  const theme = useContext(ThemeContext);
  return (
    <>
      <div
        className="container__background"
        style={{ background: `${theme.primary}` }}
      >
        <div className="basic__info">
          <div className="input__background">
            <span className="first__info">
              Escola: <span>{schoolName}</span>
            </span>
          </div>
          <div className="input__background">
            <span className="first__info">
              Série/Ano Escolar: <span>{schoolYear}</span>
            </span>
          </div>
        </div>
        <div className="basic__info">
          <div className="input__background">
            <span className="first__info">
              {/* Exemplo: REDE Juina | Juina |  */}
              REDE/Município: <span>{dreAndMunicipio}</span>
            </span>
          </div>
          <div className="input__background">
            <span className="first__info">
              Estudante: <span>{student}</span>
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

HeaderAvalia.propTypes = {
  schoolName: PropTypes.string,
  schoolYear: PropTypes.string,
  dreAndMunicipio: PropTypes.string,
  student: PropTypes.string
};

export default HeaderAvalia;
